import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getWarehouseGarmentsByStatus = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/ware-house/' +
      warehouseId +
      '/qrcode-by-status',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getReadyGarmentToSendToStore = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/warehouse/api/secure/v1/ware-house/' + warehouseId + '/bulk-qrcode',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreByWarehouseInfo = warehouseId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/ware-house/' +
      warehouseId +
      '/store',
    headers: getHeaders(),
  });
};

export const toGenerateChallanFromWarehouse = warehouseStoreId => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/ware-house-store/' +
      warehouseStoreId +
      '/challan/SENT_TO_STORE',
    headers: getHeaders(),
    // data: JSON.stringify(data),
  });
};

export const postSendToStore = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/ware-house/' +
      warehouseId +
      '/send-to-store',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getWarehouseGarmentsByStageProcessStatus = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/warehouse/api/secure/v1/ware-house/' + warehouseId + '/qrcode-stage-process-status',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};